"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.networkHealthConfiguration = void 0;
/**
 * Defines configuration for network health data
 *
 * numMetricsSamplesToUseForAggregation
 * ---------------------------------------
 * No. of metrics samples to be collected and aggregated
 * before we send/update network health stats
 * A value of N means we use N samples to aggregate before we use/send network health data
 * It also means we roughly use/send this data every N seconds
 *
 * chimeDataChannelName
 * ----------------------
 * We use Chime's data channel to send network health messages to other attendees
 * This defines the name of the channel to be used
 *
 * chimeDataMessageLifetime
 * -------------------------
 * Lifetime of the message in Chime's data channel in ms
 * Messages are stores in Chime's media server for this duration and will be delivered
 * if an attendee reconnects or joins late
 */

var networkHealthConfiguration = exports.networkHealthConfiguration = {
  numMetricsSamplesToUseForAggregation: 3,
  chimeDataChannelName: 'NetworkHealth',
  chimeDataMessageLifetime: 10000
};